import * as React from "react";
import { useGetConfigAppQuery } from "../../../utils/api/config/config.api";
import { createMarkup } from "../../../utils/Utils";
import { TextSkeleton } from "../../admin/Parametres/Steps/CguAdmin";
import FooterPage from "../../auth/FooterPage";
import { AlertInfo } from "../../common/Alert";
import FrontFooter from "../FrontFooter/FrontFooter";
import PureHeader from "../FrontHeader/PureHeader";

const MentionLegale = () => {
  const { data, isLoading } = useGetConfigAppQuery();
  return (
    <div className="landing-page-component">
      <PureHeader />
      <div className="page-content bg-white py-5">
        <div className="container-easy-market">
          <div className="container">
            <div className="container-banner-policy">
              <h2 className="title-banner-policy">
                Politique de Confidentialité
              </h2>
            </div>
            <div className="container-text-policy pb-5">
              {!!isLoading && <TextSkeleton />}
              {!isLoading &&
                (data?.ptc ? (
                  <p
                    className="text-policy"
                    dangerouslySetInnerHTML={createMarkup(data?.ptc)}
                  />
                ) : (
                  <AlertInfo message="Le contenu de la politique de confidentialité n'est pas encore disponible" />
                ))}
            </div>
          </div>
          {/* <FooterPage /> */}
        </div>
      </div>
      <FrontFooter />
    </div>
  );
};

export default MentionLegale;
